
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import ProjectModel from '@/views/Project/Project/models/project'

import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import ModuleSettingsBody from '@/views/Project/Settings/Modules/components/modulesBody.vue'
import ForbiddenView from '@/views/App/views/ForbiddenView/ForbiddenView.vue'

const ModulesSettingsView = Vue.extend({
    mixins: [ProjectMixin],
    components: { ToolbarComponent, ModuleSettingsBody, ForbiddenView },

    computed: {
        allowedAccess() {
            return this.hasPermission(this.currentProjectPermissions, this.requiredPermissions)
        },
        project(): ProjectModel {
            return new ProjectModel(this.currentProject)
        },
    },
})
export default ModulesSettingsView
